export enum UnitInputType {
  DefaultValue = 'defaultValue',
  MinValue = 'minValue',
  MaxValue = 'maxValue',
}
